import type { ApiResponse } from '../types';
import type { ScheduleId } from '@/types/schedule';
import type { ICreateNotificationState } from '@/store/types';

import { v3Get, v3Post } from '@/api/axios.instance.V3';
import routes from '@/config/routes';
import { zonedTimeToUtcTime } from '@/helpers';

interface ISetAgentsListPayloadObj {
  scheduleId: ScheduleId;
  startDate: Date;
  endDate: Date;
}

interface IcreateNotificationPayload {
  scheduleId: ScheduleId;
  scheduleName?: string;
  clientId?: number;
  agentsRequired: number;
  dateStart: Date | string | null;
  dateEnd: Date | string | null;
  description: string;
  customText: string;
  internalNotes: string;
  useVoice: boolean;
  useSms: boolean;
  useMail: boolean;
}

const getNotifyJobListByClientId = (ClientId: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.notify.getNotifyJobList + ClientId}`);

const getNotifyQueueList = (NotifyJobId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.notify.getNotifyQueueList + NotifyJobId}`);

const getSchudulelistByClientId = (ClientId: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.notify.getSchudulelistWithClientId + ClientId}`);

const setNotifyPreview = (payload: ISetAgentsListPayloadObj): ApiResponse => {
  return v3Post(`${routes.backendUrl.notify.setNotifyPreview}`, payload);
};

const getNotifyJobCreate = (payload: ICreateNotificationState, timeZone = ''): ApiResponse | number => {
  const updatedPayload: IcreateNotificationPayload = payload;
  updatedPayload.dateStart = payload.dateStart
    ? zonedTimeToUtcTime(new Date(payload.dateStart), timeZone)
    : payload.dateStart;
  updatedPayload.dateEnd = payload.dateEnd ? zonedTimeToUtcTime(new Date(payload.dateEnd), timeZone) : payload.dateEnd;
  return v3Post(`${routes.backendUrl.notify.getNotifyJobCreate}`, updatedPayload);
};

export const notifyApi = {
  getNotifyJobListByClientId,
  getNotifyQueueList,
  getSchudulelistByClientId,
  setNotifyPreview,
  getNotifyJobCreate,
};
